import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        console.log("connected tab controller");
        this.element.querySelectorAll('.tab').forEach((tab) => {
            tab.addEventListener('click', () => this.toggleTab(tab));
            this.toggleTabHeight(tab);
        });
    }

    toggleTab(tab) {
        // Disable tab functionality if the tab has no data-tab, used for buttons as tabs.
        if (!tab.getAttribute('data-tab')) {
            return;
        }

        const parent = tab.parentNode.parentNode;

        for (const tabInner of parent.querySelectorAll('.tab')) {
            tabInner.classList.remove('active');
        }

        for (const tabContent of parent.querySelectorAll('.tab-content')) {
            tabContent.classList.remove('active');
        }

        const content = parent.querySelector(`.${tab.getAttribute('data-tab')}`);
        tab.classList.add('active');
        content.classList.add('active');
        this.recalculateHeight(tab);
    }

    recalculateHeight(tab) {
        const parent = tab.parentNode.parentNode;
        for (const tabContent of parent.querySelectorAll('.tab-content')) {
            tabContent.setAttribute('data-height', tabContent.offsetHeight);
            const height = tabContent.querySelector('.tab-content-inner').offsetHeight;
            const startHeight = tabContent.hasAttribute('data-enable-height') ? tabContent.getAttribute('data-enable-height') : 350;
            const moreBtn = tabContent.querySelector('.btn-toggle-more');
            if (moreBtn) {
                if (height < startHeight) {
                    tabContent.classList.remove('tab-toggle-content');
                    moreBtn.classList.add('hidden');
                } else {
                    tabContent.classList.add('tab-toggle-content');
                    moreBtn.classList.remove('hidden');
                }
            }
        }
    }

    toggleTabHeight(tab) {
        const parent = tab.parentNode.parentNode;
        const tabContent = parent.querySelector(`.${tab.getAttribute('data-tab')}`);
        tabContent.setAttribute('data-height', tabContent.offsetHeight);
        const height = tabContent.querySelector('.tab-content-inner').offsetHeight;
        const startHeight = tabContent.hasAttribute('data-enable-height') ? tabContent.getAttribute('data-enable-height') : 350;
        const moreBtn = tabContent.querySelector('.btn-toggle-more');
        if (moreBtn) {
            if (height < startHeight) {
                tabContent.classList.remove('tab-toggle-content');
                moreBtn.classList.add('hidden');
            } else {
                tabContent.classList.add('tab-toggle-content');
                moreBtn.classList.remove('hidden');
            }
            moreBtn.addEventListener('click', function () {
                tabContent.classList.toggle('tab-content-expanded');
                const altTitle = moreBtn.getAttribute("data-alt-title");
                const altTitleOld = moreBtn.innerHTML;
                moreBtn.innerHTML = altTitle;
                moreBtn.classList.toggle('btn-plus');
                moreBtn.classList.toggle('btn-minus');
                moreBtn.setAttribute('data-alt-title', altTitleOld);
            });
        }
    }
}
